import { render } from "./StartButton.vue?vue&type=template&id=75bf558f&scoped=true"
import script from "./StartButton.vue?vue&type=script&lang=js"
export * from "./StartButton.vue?vue&type=script&lang=js"

import "./StartButton.vue?vue&type=style&index=0&id=75bf558f&scoped=true&lang=sass"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75bf558f"]])

export default __exports__